import {
  IServicesIaCustomerSuscriptionsBackendRequestDto,
  IServicesIaCustomerSuscriptionsBackendResponse,
} from '../interfaces/IServicesIaCustomerSuscriptionsBackend';

export const servicesIaCustomerSuscriptionsMapper = {
  toDto: (values: any): IServicesIaCustomerSuscriptionsBackendRequestDto => {
    return {
      customerId:
        typeof values.customerId === 'object' && values.customerId !== null
          ? values.customerId?.value
          : values.customerId,
      planId:
        typeof values.planId === 'object' && values.planId !== null
          ? values.planId?.value
          : values.planId,
      startsAt: values.startsAt || undefined,
      expiresAt: values.expiresAt || undefined,
      renewalType:
        typeof values.renewalType === 'object' && values.renewalType !== null
          ? values.renewalType?.value
          : values.renewalType,
      nextRenewalAt: values.nextRenewalAt || undefined,
      statusSuscription:
        typeof values.statusSuscription === 'object' && values.statusSuscription !== null
          ? values.statusSuscription?.value
          : values.statusSuscription,
    };
  },
  toEditDto: (values: any): Partial<IServicesIaCustomerSuscriptionsBackendRequestDto> => {
    return {
      planId:
        typeof values.planId === 'object' && values.planId !== null
          ? values.planId?.value
          : values.planId,
      startsAt: values.startsAt || undefined,
      expiresAt: values.expiresAt || undefined,
      renewalType:
        typeof values.renewalType === 'object' && values.renewalType !== null
          ? values.renewalType?.value
          : values.renewalType,
      nextRenewalAt: values.nextRenewalAt || undefined,
      statusSuscription:
        typeof values.statusSuscription === 'object' && values.statusSuscription !== null
          ? values.statusSuscription?.value
          : values.statusSuscription,
    };
  },
  toDomain: (item: any): any => {
    const isPlanIdObject = typeof item.planId === 'object' && item.planId !== null;

    const planObj = isPlanIdObject
      ? item.planId
      : item.plan
        ? {
            value: item.plan.id,
            label: item.plan.name,
            price: item.plan.monthlyPrice,
            currency: item.plan.currency,
            monthlyCredits: item.plan.monthlyCredits,
            duration: item.plan.durationDays,
          }
        : null;

    return {
      id: item.id,
      customerId: item.customerId || item.tenantId || '',
      customer: item.customer || null,
      planId: planObj || item.planId || '',
      planName: item.plan?.name || (isPlanIdObject ? item.planId.label : '') || '',
      startsAt: item.startsAt,
      expiresAt: item.expiresAt,
      renewalType: item.renewalType,
      monthlyCredits:
        Number(item.plan?.monthlyCredits) ||
        (isPlanIdObject ? Number(item.planId.monthlyCredits) : 0) ||
        Number(item.monthlyCredits) ||
        0,
      price:
        Number(item.plan?.monthlyPrice) || (isPlanIdObject ? Number(item.planId.price) : 0) || 0,
      currency: item.plan?.currency || (isPlanIdObject ? item.planId.currency : 'USD'),
      durationDays: item.plan?.durationDays || (isPlanIdObject ? item.planId.duration : 0),
      maxRequestsDay:
        item.plan?.maxRequestsDay || (isPlanIdObject ? item.planId.maxRequestsDay : 0),
      maxRequestsMonth:
        item.plan?.maxRequestsMonth || (isPlanIdObject ? item.planId.maxRequestsMonth : 0),
      maxAssistants: item.plan?.maxAssistants || (isPlanIdObject ? item.planId.maxAssistants : 0),
      maxAgents: item.plan?.maxAgents || (isPlanIdObject ? item.planId.maxAgents : 0),
      maxUsers: item.plan?.maxUsers || (isPlanIdObject ? item.planId.maxUsers : 0),
      allowChat: item.plan?.allowChat || (isPlanIdObject ? item.planId.allowChat : false),
      allowImages: item.plan?.allowImages || (isPlanIdObject ? item.planId.allowImages : false),
      allowAudio: item.plan?.allowAudio || (isPlanIdObject ? item.planId.allowAudio : false),
      allowDocuments:
        item.plan?.allowDocuments || (isPlanIdObject ? item.planId.allowDocuments : false),
      allowEmbeddings:
        item.plan?.allowEmbeddings || (isPlanIdObject ? item.planId.allowEmbeddings : false),
      allowMemory: item.plan?.allowMemory || (isPlanIdObject ? item.planId.allowMemory : false),
      allowTools: item.plan?.allowTools || (isPlanIdObject ? item.planId.allowTools : false),
      allowRag: item.plan?.allowRag || (isPlanIdObject ? item.planId.allowRag : false),
      nextRenewalAt: item.nextRenewalAt,
      status: item.status,
      statusSuscription: item.statusSuscription,
      createdAt: item.createdAt,
      updatedAt: item.updatedAt,
    };
  },
};
